import { render, staticRenderFns } from "./ViewPrintPatientHistory.vue?vue&type=template&id=48d90f38&scoped=true&"
import script from "./ViewPrintPatientHistory.vue?vue&type=script&lang=js&"
export * from "./ViewPrintPatientHistory.vue?vue&type=script&lang=js&"
import style0 from "./ViewPrintPatientHistory.vue?vue&type=style&index=0&id=48d90f38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d90f38",
  null
  
)

export default component.exports